module.exports = __webpack_public_path__ + "static/media/profileNavLogo.cf97a14b.svg";